import React from 'react';
import { connect } from 'react-redux';

import Slider from 'react-slick';
import RangeDisplayCard from '../RangeDisplayCard/';

import { gtmCardEvent } from '../../../services/gtmService';

const TYPE_SWITCH = {
  favourites: 'favourites',
  recentlyviewed: 'recent',
};

const GTM_SWITCH = {
  favourites: 'favourites',
  recentlyviewed: 'recently-viewed',
};

function getRandomUniqueNumber(currentNumbers, min, max) {
  const randomNumber = Math.floor(Math.random() * max) + min;
  if (currentNumbers.includes(randomNumber)) return getRandomUniqueNumber(currentNumbers, min, max);
  return randomNumber;
}

function selectRandomRanges(ranges, maxRanges) {
  const maxIndex = ranges.length - 1;
  return Array.from({ length: maxRanges }, (v, i) => i)
    .reduce(acc => [...acc, getRandomUniqueNumber(acc, 0, maxIndex)], [])
    .map(index => ranges[index]);
}



class ActivitySliderCard extends React.Component {

  constructor(props) {
    super(props);
    this.currentSlide = 0;
    this.beforeSlideChange = this.beforeSlideChange.bind(this);
  }

  beforeSlideChange(oldIndex, newIndex) {
    // this.currentSlide is a workaround as beforeChange is broken in the library
    // https://github.com/akiran/react-slick/issues/1216
    const activityType = this.props.type[0].toLowerCase();
    gtmCardEvent(GTM_SWITCH[activityType], 'swipe-range', this.randomSelection[this.currentSlide].rangeNameForUrl)();
    this.currentSlide = newIndex;
  }

  render() {
    const { title, type, xmasCountDown, xmasCutOffDate, ...rest } = this.props;

    const activityType = type[0].toLowerCase();
    const ranges = rest[TYPE_SWITCH[activityType]];

    if (!ranges || !ranges.length) return null;
    this.randomSelection = ranges.length > 5 ? selectRandomRanges(ranges, 5) : ranges;
    return (
      <div>
        <Slider
          beforeChange={this.beforeSlideChange}
          {...{ infinite: true, arrows: false, dots: true, dotsClass: 'range-display__dots' }}
          style={{ width: '100%' }}
        >
          {this.randomSelection.map(range => (
            <div key={`${type}-slider-${range.rangeName}`}>
              <RangeDisplayCard
                activityType={activityType}
                titleFormat={title}
                range={range}
                xmasCountDown={!!parseInt(xmasCountDown, 10)}
                xmasCutOffDate={xmasCutOffDate}
              />
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  favourites: state.activity.favourites,
  recent: state.activity.recent
});

export default connect(mapStateToProps, null)(ActivitySliderCard);



// WEBPACK FOOTER //
// ./src/cards/templates/ActivitySliderCard/index.js